import React, {useState} from "react";
import {useParams} from "react-router-dom";
import {useDeleteSubdivisionDocumentMutation, useGetSubdivisionDocumentsByIdQuery} from "../subDivisionApi";
import CommonDocumentsGrid from "../../../../components/common/DocumentsGrid/CommonDocumentsGrid";
import DocumentUploadSection from "../../../order/modal/UploadDocumentModal";
import {useLazyViewAssociationsFileQuery} from "../../../hoa/association/associationApi";
import MultiSelectDocModal from "../../../../components/common/DocumentsGrid/Modal/MultiSelectDocModal";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";

const SubdivisionDocuments = () => {

    const {subdivisionId} = useParams();
    const [showUploadDocModal, setShowUploadDocModal] = useState(false);
    const [viewFile] = useLazyViewAssociationsFileQuery();
    const [showMultiDocSelectModal, setShowMultiDocSelectModal] = useState(false);
    const [showDeleteSubdivisionDocumentModal, setShowDeleteSubdivisionDocumentModal] = useState(false);
    const [subdivisionDocId, setSubdivisionDocId] = useState("");

    const {
        data: documentsData,
    } = useGetSubdivisionDocumentsByIdQuery(subdivisionId || "");


    const [deleteSubdivisionDoc, {isLoading}] = useDeleteSubdivisionDocumentMutation();


    const handleViewDownloadFile = async ({
                                              id,
                                              shouldOpen
                                          }: {
        id: string;
        shouldOpen: boolean;
    }) => {
        viewFile({fileId: id, isDownload: shouldOpen});
    };
    const onDelete = (id: any) => {
        setShowDeleteSubdivisionDocumentModal(true);
        setSubdivisionDocId(id);
    };
    const handleDelete = async () => {
        if (subdivisionDocId) {
            await deleteSubdivisionDoc(subdivisionDocId).unwrap();
        }
    };


    return (
        <>
            <CommonDocumentsGrid
                data={documentsData}
                title="Subdivision Documents"
                count={documentsData?.length || 0}
                hasAddPermission={true}
                hasSortPermission={true}
                companyId={subdivisionId}
                isLoading={isLoading}
                onClick={handleViewDownloadFile}
                setShowUploadDocModal={setShowUploadDocModal}
                setShowMultiDocSelectModal={setShowMultiDocSelectModal}
                addPermission={'SUBDFIL-C'}
                onDelete={onDelete}
            />
            {
                showUploadDocModal &&
                <DocumentUploadSection show={showUploadDocModal} setShow={setShowUploadDocModal}
                                       relationalId={subdivisionId} tgxFileType={"SUBDIVISION_FILE"}
                                       EnumType={"SubdivisionFileType"} fileDataTypeDefault={"OTHER"}


                />
            }
            {
                showMultiDocSelectModal && (
                    <MultiSelectDocModal show={showMultiDocSelectModal}
                                         setShow={setShowMultiDocSelectModal}

                    />
                )
            }

            {
                showDeleteSubdivisionDocumentModal &&
                <ConfirmationModal
                    title={"Delete Subdivision Document"}
                    bodyMessage={"Are you sure you want to delete this document"}
                    onSubmit={handleDelete}
                    isLoading={isLoading}
                    show={showDeleteSubdivisionDocumentModal}
                    setShow={setShowDeleteSubdivisionDocumentModal}
                />
            }
        </>
    );
};

export default SubdivisionDocuments;